import axios from '@/api/config';

const system = {
  login(data) {
      return axios.post(`${process.env.BASE_URL}/agentUserInfo/login`, data);
  },
  getSMSCode(data) {
    return axios.post(`${process.env.BASE_URL}/system/sendSMSCode4RegisterAgentInfo`, data);
  },
  resetPassword(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/modifyPasswordBySms`, data);
  },
  getAdminSMSCode(data) {
      return axios.post(`${process.env.BASE_URL}/login/getAdminLoginSMSCode`, data);
  },
  loginByCode(data) {
    return axios.post(`${process.env.BASE_URL}/login/loginByCode`, data);
  },
}

export default system;



// WEBPACK FOOTER //
// ./src/api/system.js